<script>
  import axios from 'axios'
  import { subscribe } from '../helpers/subscribe'
  import { FormHandler } from '../admin/helpers/formHandler'
  import Container from '../components/Container.svelte'
  import Block from '../components/Block.svelte'
  import Input from '../components/Input.svelte'
  import Checkbox, {CheckboxHandler} from '../components/Checkbox.svelte'
  import Select, { SelectHandler } from '../components/Select.svelte'
  import Placeholder from '../components/Placeholder.svelte'

  export let modalMsgHandler, formNode

  export let autorizoHandler = new CheckboxHandler(false)
	export let storeAutorizo = autorizoHandler.store()
  
  export let termosHandler = new CheckboxHandler(false)
	export let storeTermos = termosHandler.store()

  let selectOptions = {
    data: {
      items: []
    }
  }

  export let diaHandler = new SelectHandler(true)
  export let diaStore = subscribe()
  diaStore.set(selectOptions.data)
  export let diaOptionsStore = subscribe()
  function diaPopulate(_diaHandler) {
    let options = []
    let dia = 1
    let i = 0
    while (dia <= 31) {
      i++
      options.push({
        text: `${('0'+dia).slice(-2)}`, value: `${('0'+dia).slice(-2)}`
      })
      dia++
      if (i == options.length) {
        setTimeout(function() {
          _diaHandler.optionsInit(options, _diaHandler, null)
            .then((data) => {
                _diaHandler.action(null, 'Dia')()
                diaOptionsStore.set({data})
              })
        }, 200)
      }
    }
  }
  diaPopulate(diaHandler)

  export let mesHandler = new SelectHandler(true)
  export let meses = [
    {text: 'Janeiro', value: '01'},
    {text: 'Fevereiro', value: '02'},
    {text: 'Março', value: '03'},
    {text: 'Abril', value: '04'},
    {text: 'Maio', value: '05'},
    {text: 'Junho', value: '06'},
    {text: 'Julho', value: '07'},
    {text: 'Agosto', value: '08'},
    {text: 'Setembro', value: '09'},
    {text: 'Outubro', value: '10'},
    {text: 'Novembro', value: '11'},
    {text: 'Dezembro', value: '12'}
  ]
  mesHandler.store()
  setTimeout(function() {
    mesHandler.action(null, 'Mês')()
  }, 200)

  export let anoHandler = new SelectHandler(true)
  export let anoStore = subscribe()
  anoStore.set(selectOptions.data)
  export let anoOptionsStore = subscribe()
  function anoPopulate(_anoHandler) {
    let options = []
    let ano = 1922
    let i = 0
    while (ano <= 2006) {
      i++
      options.push({
        text: ano, value: ano
      })
      ano++
      if (i == options.length) {
        setTimeout(function() {
          _anoHandler.optionsInit(options.reverse(), _anoHandler, null)
            .then((data) => {
                _anoHandler.action(null, 'Ano')()
                anoOptionsStore.set({data})
              })
        }, 200);
      }
    }
  }
  anoPopulate(anoHandler)

  export let estadoHandler = new SelectHandler(true)
  export let estados = [
    {text: 'AC', value: 'AC'},
    {text: 'AL', value: 'AL'},
    {text: 'AP', value: 'AP'},
    {text: 'AM', value: 'AM'},
    {text: 'BA', value: 'BA'},
    {text: 'CE', value: 'CE'},
    {text: 'DF', value: 'DF'},
    {text: 'ES', value: 'ES'},
    {text: 'GO', value: 'GO'},
    {text: 'MA', value: 'MA'},
    {text: 'MT', value: 'MT'},
    {text: 'MS', value: 'MS'},
    {text: 'MG', value: 'MG'},
    {text: 'PA', value: 'PA'},
    {text: 'PB', value: 'PB'},
    {text: 'PR', value: 'PR'},
    {text: 'PE', value: 'PE'},
    {text: 'PI', value: 'PI'},
    {text: 'RJ', value: 'RJ'},
    {text: 'RN', value: 'RN'},
    {text: 'RS', value: 'RS'},
    {text: 'RO', value: 'RO'},
    {text: 'RR', value: 'RR'},
    {text: 'SC', value: 'SC'},
    {text: 'SP', value: 'SP'},
    {text: 'SE', value: 'SE'},
    {text: 'TO', value: 'TO'}
  ]

  export let cidadeHandler = new SelectHandler(true)
  export let cidadeStore = subscribe()
  cidadeStore.set(selectOptions.data)
  export let cidadeOptionsStore = subscribe()
  function cidadePopulate(_cidadeHandler, UF) {
    if (UF.length == 0) return
    axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/municipios`)
      .then((res) => {
        let options = []
        let i = 0
        for (const cidade of res.data) {
          i++
          options.push({
            text: cidade.nome,
            value: cidade.nome
          })
          if (i == res.data.length) {
            _cidadeHandler.optionsInit(options, _cidadeHandler, null)
              .then((data) => {
                document.querySelector('#cidade input.search').value = ''
                _cidadeHandler.action(null, 'Escolha uma opção')()
                cidadeOptionsStore.set({data})
              })
          }
        }
      })
  }
  function cidadePopulateTrigger() {
    setTimeout(function() {
      let UF = document.querySelector('input[name="estado"]').value
      cidadePopulate(cidadeHandler, UF)
    }, 100)
  }

  function msgModal(title, subtitle, status) {
    let data = modalMsgHandler.data
    data.title = title
    data.subtitle = subtitle
    data.status = status
    storeTermos.set(data)
    modalMsgHandler.action()
  }

  let dataLoaded = {
    data: {
      loaded: true
    }
  }
  export let loaderStore = subscribe()
  loaderStore.set(dataLoaded.data)

  export let formHandler = new FormHandler(msgModal, loaderStore, dataLoaded, null, modalMsgHandler)
  function formSubmit() {
    formHandler.submit(formNode)
  }
</script>

<form bind:this={formNode}>
  <Container
    spacing=12
    style="margin-left: -12px; padding-right: 0; width: calc(100% + 12px);"
  >
    <Block l=100>
      <Input
        name="nome"
        type="text"
        label="Nome"
      />
    </Block>
    <Block l=100>
      <Input
        name="instagram"
        type="text"
        label="Instagram"
      />
    </Block>
    <Block l=100>
      <Input
        name="email"
        type="text"
        label="Email"
      />
    </Block>
    <Block l=100>
      <Input
        name="celular"
        type="text"
        label="Celular"
      />
    </Block>
    <div class="nascimento-label">
      Data de nascimento
    </div>
    <Block l=33 s=50>
      <Select
        id="dia"
        label={false}
        name="dia_nascimento"
        filter={true}
        options={$diaStore.items}
        selected={null}
        selectHandler={diaHandler}
        opctionsStore={diaOptionsStore}
      />
    </Block>
    <Block l=33 s=50>
      <Select
        id="mes"
        label={false}
        name="mes_nascimento"
        filter={true}
        options={meses}
        selected={null}
        selectHandler={mesHandler}
      />
    </Block>
    <Block l=33 s=100>
      <Select
        id="ano"
        label={false}
        name="ano_nascimento"
        filter={true}
        options={$anoStore.items}
        selected={null}
        selectHandler={anoHandler}
        opctionsStore={anoOptionsStore}
      />
    </Block>
    <Block l=100>
      <Input
        name="cep"
        type="text"
        label="CEP"
      />
    </Block>
    <Block l=100>
      <Input
        name="endereco"
        type="text"
        label="Endereço*"
      />
    </Block>
    <Block l=33>
      <Input
        name="numero"
        type="text"
        label="Nº"
      />
    </Block>
    <Block l=66>
      <Input
        name="complemento"
        type="text"
        label="Complemento"
      />
    </Block>
    <Block l=100>
      <Input
        name="bairro"
        type="text"
        label="Bairro"
      />
    </Block>
    <Block l=33 s=100>
      <Select
        id="estado"
        label="Estado"
        name="estado"
        filter={true}
        options={estados}
        selected={null}
        selectHandler={estadoHandler}
        onChange={cidadePopulateTrigger}
      />
    </Block>
    <Block l=66 s=100>
      <Select
        id="cidade"
        label="Cidade"
        name="cidade"
        filter={true}
        options={$cidadeStore.items}
        selected={null}
        selectHandler={cidadeHandler}
        opctionsStore={cidadeOptionsStore}
      />
    </Block>
    <Block l=100 style="padding-top: 36px;">
      <Checkbox
        label="Eu autorizo a coleta e o armazenamento dos meus dados pessoais pela BIC para recebimento de comunicados sobre produtos, eventos e novidades da BIC e do Mundo BIC."
        name="autorizo_coleta_dados"
        store={storeAutorizo}
        onclick={autorizoHandler.action.bind(autorizoHandler)}
      />
    </Block>
    <Block l=100>
      <Checkbox
        label="Li e aceito a <a href='/politica-de-privacidade' target='_blank'>Política de Privacidade</a> do site."
        name="aceito_regulamento_e_politica"
        store={storeTermos}
        onclick={termosHandler.action.bind(termosHandler)}
      />
    </Block>
    <Block l=100 style="text-align: center;">
      {#if !$loaderStore.loaded}
        <Placeholder
          style="width: 214px; height: 63px; margin: auto;"
        />
      {:else}
        <button type="button" on:click={formSubmit}>
          <img src="/img/btn2.png" alt="Enviar">
        </button>
      {/if}
    </Block>
  </Container>
</form>

<style lang="scss">
  @import '../scss/media-sizes';
  .nascimento-label {
    width: 100%;
    padding-left: 12px;
    padding-top: 12px;
    margin-bottom: -12px;
    font-family: "myriad-pro", sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #fff;
  }
  button {
    img {
      cursor: pointer;
      margin: auto;
      width: 80%;
      display: block;
    }
  }
  @media screen and (max-width: $mediaQueryMid) {
    .nascimento-label {
      font-size: 16px;
    }
    button {
      img {
        width: 90%
      }
    }
  }
</style>